enum PhoneNumberLength {
    US = 10,
}

export const formatPhoneNumber = (phoneNumber: string | undefined) => {
    if (phoneNumber) {
        const justNumbers = phoneNumber.replace(/[^0-9]/g, '');
        if (justNumbers.length === PhoneNumberLength.US) {
            return `${justNumbers.slice(0, 3)}-${justNumbers.slice(
                3,
                6
            )}-${justNumbers.slice(6)}`;
        }
    }
    return phoneNumber ?? '';
};
